import { TextField } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState,setTotalValues } from "./defineSlice";
import './Define.css'
import { formatNumber, removeComma } from "./defineUtils";

export default function TableCellWeek4(params) {
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const { gridData, gridDataFiltered, isWeek4Only } = define;
   const [week4, setWeek4] = useState(params.row.weekly4);
   const customerID = params.row.customerID;
   const customerGroupID = params.row.customerGroupID;
   const productGroupID = params.row.productGroupID;
   const skuid = params.row.skuid;

   useEffect(()=>{
      setWeek4(params.row.weekly4);
   },[params.row.weekly4]);

   function updateGrid(hasError, w) {
      let updatedItem = null;
      const updated = gridDataFiltered.map((item, index) => {
         const flag =
            item.customerID === customerID &&
            item.customerGroupID === customerGroupID &&
            item.productGroupID === productGroupID &&
            item.skuid === skuid;
         if (flag === true) {
            updatedItem = {
               ...item,
               hasError,
               weekly4: !w ? 0 : w,
            };
            return updatedItem;
         }
         return item;
      });

      const updatedGrid = [];
      for (let i = 0; i < gridData.length; ++i) {
         const item = gridData[i];
         if(item.id === updatedItem.id) {
            updatedGrid.push(updatedItem);
         }
         else {
            updatedGrid.push(item);
         }
      }
      dispatch(setState("gridDataFiltered", updated));
      dispatch(setState("gridData", updatedGrid));
   }

   function updateWeek4(event) {
      let w4 = removeComma(event.target.value);
      w4 = Number(w4);
      let w5 = Number(params.row.weekly5);
      let w3 = Number(params.row.weekly3);
      let hasError = false;
      setWeek4(w4);
      if(!w4 && w4!==0) {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Only numbers are allowed."));
         return;
      }

      if(w3 > w4) {
         hasError = true;
      }
      else if(w4 > w5) {
         hasError = true;
      }
      dispatch(setState("gridDataChanged", true));
      updateGrid(hasError, w4);
      dispatch(setTotalValues());
   }
   function handleValidity(w3, w4, w5){
      if(w3 > w4) {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Must be greater or equal to Week3"));
      }
      else if(w4 > w5) {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Must be less or equal to Week5"));
      }
   }
   return (
      <TextField
         variant="standard"
         disabled={isWeek4Only}
         value={week4?.toLocaleString('en-US')}
         className={params.row.weekly4 > params.row.weekly5 ? 'red-row' : ''}
         onChange={updateWeek4}
         onBlur={() => {
            handleValidity(params.row.weekly3, params.row.weekly4, params.row.weekly5);
         }}
         sx={{ width: 100 }}
         inputProps={{ style: {textAlign: 'center' } }}
      />
   );
}
